import React, { useRef } from "react";
import Tooltip from "@mui/material/Tooltip";

export default function BackupImageUploaderPanel({
  isDragActive,
  uploadStatus,
  selectedFile,
  selectedFileSizeLabel,
  backupImageDimensionsLabel,
  fileInputRef,
  maxFileSizeLabel,
  uploadProgressIcon,
  emptyStateIcon,
  truncateFileName,
  getOriginalFilename,
  onDrop,
  onDragOver,
  onDragLeave,
  onChooseFile,
  onFileInputChange,
  onOpenUploadCancelConfirmation,
  onOpenDeleteConfirmation,
}) {
  const isUploading = Boolean(uploadStatus?.isUploading);
  const hasSelectedFile = Boolean(selectedFile);
  const boundaryRef = useRef(null);


  return (
    <div className="backup-image-settings-uploader">
      <div className="panel-title">Upload Backup Image</div>
      <div
        ref={boundaryRef}
        className={`upload-dropzone ${isDragActive ? "drag-active" : ""} ${
          isUploading ? "uploading" : ""
        } ${hasSelectedFile ? "has-file" : ""}`}
        onDrop={(event) => {
          if (isUploading) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          onDrop(event);
        }}
        onDragOver={(event) => {
          if (isUploading) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          onDragOver(event);
        }}
        onDragLeave={(event) => {
          if (isUploading) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          onDragLeave(event);
        }}
        onClick={isUploading || hasSelectedFile ? undefined : onChooseFile}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept=".jpg,.jpeg,.png"
          className="file-input-hidden"
          onChange={onFileInputChange}
        />
        {isUploading ? (
          <div
            className="upload-progress-card"
            onClick={(event) => event.stopPropagation()}
          >
            <img
              src={uploadProgressIcon}
              alt=""
              className="upload-progress-icon"
            />
            <div className="upload-progress-file-row">
              <span className="upload-progress-file-name">
                {uploadStatus.fileName}
              </span>
              <span className="upload-progress-file-size">
                {uploadStatus.fileSize}
              </span>
            </div>
            <div className="upload-progress-status-row">
              <div className="upload-progress-bar-track">
                <div
                  className="upload-progress-bar-fill"
                  style={{ width: `${uploadStatus.progress}%` }}
                />
              </div>
              <div className="upload-progress-percent">{`${uploadStatus.progress}%`}</div>
            </div>
            <button
              type="button"
              className="upload-progress-cancel"
              onClick={(event) => {
                event.stopPropagation();
                onOpenUploadCancelConfirmation();
              }}
            >
              CANCEL
            </button>
          </div>
        ) : hasSelectedFile ? (
          <div
            className="upload-selected-card"
            onClick={(event) => event.stopPropagation()}
          >
            <img
              src={uploadProgressIcon}
              alt=""
              className="upload-progress-icon"
            />
            <div className="upload-progress-file-row">
              <Tooltip
                title={getOriginalFilename(selectedFile?.name)}
                PopperProps={{
                  modifiers: [
                    {
                      name: "preventOverflow",
                      options: {
                        boundary: boundaryRef.current,
                      },
                    },
                  ],
                }}
              >
                <span className="upload-progress-file-name">
                  {truncateFileName(getOriginalFilename(selectedFile?.name))}
                </span>
              </Tooltip>
              {selectedFileSizeLabel ? (
                <span className="upload-progress-file-size">
                  {selectedFileSizeLabel}
                </span>
              ) : null}
            </div>
            <button
              type="button"
              className="upload-selected-action"
              onClick={(event) => {
                event.stopPropagation();
                onChooseFile();
              }}
            >
              REPLACE
            </button>
            <button
              type="button"
              className="upload-selected-action delete"
              onClick={(event) => {
                event.stopPropagation();
                onOpenDeleteConfirmation();
              }}
            >
              DELETE
            </button>
          </div>
        ) : (
          <div className="upload-copy">
            <img
              src={emptyStateIcon}
              alt=""
              aria-hidden="true"
              className="upload-empty-main-icon"
            />
            <div className="upload-main-text">
              Drag &amp; drop .JPG, .PNG or
              <button
                type="button"
                className="browse-link"
                onClick={(event) => {
                  event.stopPropagation();
                  onChooseFile();
                }}
              >
                Select to browse
              </button>
            </div>
            <div className="upload-meta-text">{`(Max ${maxFileSizeLabel} | Supported: JPG, PNG)`}</div>
            <div className="upload-meta-text">{`Image Dimension: ${backupImageDimensionsLabel}`}</div>
          </div>
        )}
      </div>
    </div>
  );
}
